export default {
    /**
     * 사용가능한 디바이스를 찾아줌
     * @param defaultDeviceId 선택했던 디바이스 ID
     * @param audioVideo audioVideo 객체
     * @param deviceList 디바이스 리스트
     * @returns {Promise<boolean>} 사용가능한 디바이스 ID(전체 사용 불가시 false)
     */
    async checkDevice(defaultDeviceId, audioVideo, deviceList) {
        const newCameraList = deviceList.filter(item => item.deviceId !== defaultDeviceId);
        const deviceBind = function (bindDeviceId) {
            return new Promise(async (resolve) => {
                await audioVideo.chooseVideoInputDevice(bindDeviceId)
                    .then(() => {
                        resolve(bindDeviceId);
                    })
                    .catch(() => {
                        resolve(false);
                    })
            })
        }

        let deviceId = false;
        for (const item of newCameraList) {
            deviceId = await deviceBind(item.deviceId);

            if (deviceId !== false)
                break;
        }

        return deviceId;
    },
}